import type { SxProps, Theme } from '@mui/material/styles';

/**
 * Top-anchored Snackbar placement that clears the fixed AppBar (~64px).
 * Avoid `top: 8px` — that sits under the opaque AppBar even when z-index is high
 * if the snackbar is trapped in a lower stacking context.
 */
export const APP_TOP_TOAST_SNACKBAR_SX: SxProps<Theme> = {
  top: { xs: 72, sm: 80 },
  right: { xs: 8, sm: 16 },
  zIndex: (theme) => theme.zIndex.snackbar,
};
